module.exports = __webpack_public_path__ + "static/media/G1141311_Korea-10.bb0b3eb3.png";